import React from "react";
import "./SectionTopicHeader.css";

const SectionTopicHeader = ({
  title,
  subtitle,
  icon,
  rightContent,
  color = "#3B82F6",
  colorAlt,
  className = "",
  style = {},
}) => {
  const gradientTo = colorAlt || color;
  return (
    <div
      className={`section-topic-header ${className}`.trim()}
      style={{
        "--topic-gradient-from": color,
        "--topic-gradient-to": gradientTo,
        ...style,
      }}
    >
      <div className="section-topic-icon" aria-hidden="true">
        {icon}
      </div>
      <div className="section-topic-content">
        <h1 className="section-topic-title">{title}</h1>
        {subtitle && (
          <p className="section-topic-subtitle">{subtitle}</p>
        )}
      </div>
      {rightContent ? (
        <div className="section-topic-extra">{rightContent}</div>
      ) : null}
    </div>
  );
};

export default SectionTopicHeader;
